/**
 * Formats a number to a fixed number of decimal places using Indonesian locale.
 * @param {number|string} value - The value to format
 * @param {number} fractionDigits - Number of decimal digits (default 2)
 * @returns {string} Formatted decimal string (e.g. '12,50')
 */
export const formatDecimal = (value, fractionDigits = 2) => {
    if (value === null || value === undefined || value === "") return "-";
    const num = Number(value);
    if (isNaN(num)) return "-";
    return num.toLocaleString("id-ID", {
        minimumFractionDigits: fractionDigits,
        maximumFractionDigits: fractionDigits,
    });
};
